import { render, staticRenderFns } from "./Etapa4.vue?vue&type=template&id=dada8982&scoped=true&"
import script from "./etapa4.ts?vue&type=script&lang=ts&"
export * from "./etapa4.ts?vue&type=script&lang=ts&"
import style0 from "./Etapa4.vue?vue&type=style&index=0&id=dada8982&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dada8982",
  null
  
)

export default component.exports